import { ZIP_COUNTY } from "../data/ncZipCounty";

const ZIPS = {};
Object.entries(ZIP_COUNTY).forEach(([county, zips]) => zips.split(" ").forEach((z) => { ZIPS[z] = county; }));

// County and combined NC rate for a service-area zip, or null when it cannot be determined.
export const ncTaxFor = (zip, rates) => {
  const county = ZIPS[String(zip || "").trim().slice(0, 5)];
  const rate = county ? Number(rates?.[county]) : NaN;
  if (!county || !(rate > 0)) return null;
  return { county, rate };
};

export const fmtRate = (r) => `${r.toFixed(2)}%`;
export const cents = (n) => `$${n.toLocaleString("en-US", { minimumFractionDigits: 2, maximumFractionDigits: 2 })}`;
export const taxAmount = (total, rate) => Math.round(total * rate) / 100;
